import React, { useEffect, useState } from "react";
import {
  Typography,
  Card,
  CardContent,
  Box,
  IconButton,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import TextContainerField from "../../../components/TextContainerField";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById } from "../../../api/Services";
import Spinner from "../../../components/Spinner";


const ViewGeneralInsurer = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [insurerData, setInsurerData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const paramId = params.id;

      if (paramId) {
        setIsLoading(true);
        try {
          await fetchDataById(`/reference/general/insurer-master/${paramId}`).then((res) => {
            const successResponse = res?.success;
            const responseData = res?.data;
            if(successResponse){
              setInsurerData((prevData) => ({
                ...prevData,
                ...responseData
              }));
            }
          });
        } catch (err) {
          console.error(err);
        } finally {
            setIsLoading(false);
        }
      }
    };

    fetchData();
  }, [params.id]);

  if (isLoading) {
    return (
      <DashboardLayout>
        <Spinner />
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
        <Box
          sx={{
            padding: { xs: 2, md: 2 },
            bgcolor: "#f9f9f9",
            minHeight: "100vh",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="left"
            spacing={1}
            mb={2}
          >
            <IconButton
              onClick={() => navigate("/general-master/general-insurer")}
            >
              <ArrowBack />
            </IconButton>
            <Typography variant="h4" gutterBottom sx={{ fontWeight: "bold" }}>
              General Insurer Information
            </Typography>
          </Stack>

          {insurerData ? (
          <Grid container spacing={3} sx={{ mx: { xs: 0, md: 2 } }}>
            <Grid xs={12} sm={6} md={4} sx={{ width: "100%" }}>
              <Card sx={{ boxShadow: 3, borderRadius: 2, bgcolor: "white" }}>
                <CardContent>
                  <Typography variant="h6" sx={{ mb: 1, fontWeight: "600" }}>
                    {insurerData?.companyName}
                  </Typography>
                  <TextContainerField label="Insurer ID" value={insurerData?.id} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Company Name" value={insurerData?.companyName} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Company Code" value={insurerData?.companyCode} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Company Type" value={insurerData?.companyType} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Website URL" value={insurerData?.websiteUrl} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Sort Order" value={insurerData?.sortOrder} labelStyle={{ fontWeight: "500" }} />
                  <TextContainerField label="Status" value={insurerData?.isActive ? "Active" : "Inactive"} labelStyle={{ fontWeight: "500" }} 
                  valueStyle={{
                    color: insurerData?.isActive ? "green" : "red",
                  }}/>
                  {/* <TextContainerField label="Created By" value={insurerData?.createdBy} labelStyle={{ fontWeight: "500" }} /> */}
                  <TextContainerField label="Created At" value={insurerData?.createdAt} labelStyle={{ fontWeight: "500" }} />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          ) : (
            <Box>
              <Typography variant="h4" gutterBottom sx={{ textAlign: "center", fontWeight: "bold", color: "red", fontFamily: "cursive" }}>
                No Insurer Data Found
              </Typography>
            </Box>
          )}
        </Box>
    </DashboardLayout>
  );
};

export default ViewGeneralInsurer;
